import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters";

const initialState = {
  value: Number.NaN,
};

const bemessungslastSlice = createSlice({
  name: "bemessungslast",
  initialState,
  reducers: {
    setBemessungslastState(state, action) {
      state.value = action.payload.value;
    },
    setBemessungslast(state, action) {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return initialState;
    });
  },
});

export const { setBemessungslastState, setBemessungslast } = bemessungslastSlice.actions;

export default bemessungslastSlice.reducer;

export const selectBemessungslast = (state) => state.bemessungslast.value;
